import { LegalShell, Section, UPDATED } from "@/pages/Legal";
import { useConsent, resetConsent } from "@/lib/consent";

export default function CookiePolicy() {
  const consent = useConsent();
  return (
    <LegalShell eyebrow="LEGAL" title="Cookie policy" updated={UPDATED} testid="cookie-policy-page"
      seo={{ title: "Cookie Policy", description: "How Studivault uses essential browser storage and optional Google AdSense advertising cookies, and how to change your choice.", path: "/cookie-policy" }}>
      <p>
        This policy explains how Studivault, operated by <strong>Bloc Metric</strong>, India, uses cookies and
        similar technologies (such as browser local storage).
      </p>

      <Section n={1} title="Essential storage (always on)">
        <p>These are required for the Service to work and cannot be switched off:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Sign-in token</strong> — keeps you logged in (local storage).</li>
          <li><strong>Preferences</strong> — theme, notification settings, tutorial progress and your cookie choice.</li>
          <li><strong>Payment checkout</strong> — Razorpay may set cookies required to complete a payment securely.</li>
          <li><strong>Google sign-in</strong> — Google may set cookies when you choose to sign in with Google.</li>
        </ul>
      </Section>

      <Section n={2} title="Advertising (optional)">
        Free-plan users may see ads served by <strong>Google AdSense</strong>. AdSense can set cookies to show and
        measure ads, including personalised ads. AdSense is loaded <strong>only after you click "Accept all"</strong>.
        If you reject, no advertising scripts or cookies are loaded. Paid-plan users do not see ads. Learn more at{" "}
        <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer" className="text-[#B8A4FF] hover:underline">Google's advertising policies</a>.
      </Section>

      <Section n={3} title="Analytics and marketing (optional)">
        With your consent we load <strong>Google Analytics</strong> (to understand how the Service is used) and the
        <strong> Meta Pixel</strong> (to measure our ads on Facebook and Instagram, e.g. sign-ups and studies created).
        These may set cookies such as <code>_ga</code> and <code>_fbp</code>. They are loaded <strong>only after you
        click "Accept all"</strong>; if you reject or later change your choice, they are not loaded or are told to stop
        using cookies.
      </Section>

      <Section n={4} title="Your choice">
        <p>Current choice: <strong data-testid="cookie-policy-current">{consent === "accepted" ? "Accepted" : consent === "rejected" ? "Rejected non-essential" : "Not set"}</strong></p>
        <p>You can change it at any time. You can also block or delete cookies in your browser settings, although essential features may stop working.</p>
        <button className="btn-ghost text-[13px] px-4 py-2 rounded-full border border-white/10" onClick={resetConsent} data-testid="cookie-policy-change-btn">
          Change cookie choice
        </button>
      </Section>

      <Section n={5} title="Contact">
        Questions: <a href="mailto:shaurya@sanghviinfo.com" className="text-[#B8A4FF] hover:underline">shaurya@sanghviinfo.com</a>
      </Section>
    </LegalShell>
  );
}
